<template>
  <v-card class="project-card rounded-xl my-5">
    <img
      :src="require('data/assets/project_screenshots/' + screenshot_path)"
      :alt="'screenshot for project ' + title"
      style="width: 100%"
    />
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text class="pt-0">
      {{ description }}
    </v-card-text>

    <v-divider></v-divider>

    <v-card-text>
      <v-row justify="center" align="center" class="pa-4">
        <div class="stack-icon__container" style="position:relative">
          <tech-stack-icon
            v-for="stack in stacks_used"
            :key="stack"
            :stack="stack"
          />
        </div>
        <v-spacer></v-spacer>
        <span v-for="(link, index) in links" :key="index">
          <a :href="link.url" target="_blank" rel="noopener">
            <span v-if="link.primary">
              <v-btn
                color="#5d77a3"
                rounded="xl"
                flat
                size="small"
                class="primary-btn"
              >
                {{ link.text }}
              </v-btn>
            </span>
            <span v-else>
              <v-btn
                color="darkslategrey"
                rounded="xl"
                flat
                size="small"
                outlined
                class="mr-1"
                >{{ link.text }}</v-btn
              >
            </span>
          </a>
        </span>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import TechStackIcon from '@/components/utilities/TechStackIcon';

export default {
  name: 'TechProjectsCard',

  props: {
    title: String,
    description: String,
    screenshot_path: String,
    stacks_used: Array,
    links: Array,
  },

  components: {
    TechStackIcon,
  },
};
</script>

<style lang="scss" scoped>
.primary-btn {
  color: white;
}

.project-card {
  margin-bottom: 10px;
  background-color: white;
  overflow: hidden;
  box-shadow: 10px 10px 20px 5px rgba(211, 211, 211, 0.651);
}

.stack-icon__container {
  font-size: 2em;
}
</style>
